import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'lor-facet-content-item',
})
export default class LORFacetContentItem extends Vue {

    public get filterKey() {
        return this.facetItem.filterKey;
    }

    // -------------------------------------------------------
    // Properties

    public facetContent: any = {};

    @Prop()
    public facetItem: any;

    @Prop()
    public selectedFacetItem: any;

    public hasSubmenu: boolean = false;

    public customMapper: any = {
        labelKey: null,
        valueKey: null,
    };

    public isSubmitted: boolean = false;

    // -------------------------------------------------------
    // Actions

    public onClose() {
        this.$emit('onClose');
    }

    public onAdd() {
        const { items } = this.facetItem;
        this.isSubmitted = true;
        this.$validator.validate().then((valid: any) => {
            if (valid) {
                this.validateCustomMapper();
                if (!this.selectedFacetItem) {
                    items.push({...this.facetContent});
                }
                this.showSuccessToaster('Updated the facets options, Please click save button to update.', 'Updated Successfully');
                this.isSubmitted = false;
            }
        });
    }

    public onToggleSubmenu() {
        this.hasSubmenu = !this.hasSubmenu;
        const facetContent = this.facetContent;
        const subMenu = facetContent.subMenu || [];
        this.$set(this.facetContent, 'subMenu', subMenu);
        if (!this.hasSubmenu) {
            delete this.facetContent.subMenu;
        }
    }

    public onAddSubmenu() {
        const {subMenu} = this.facetContent;
        subMenu.push(this.createSubmenu());
    }

    public onDeleteSubMenu(item: any) {
        const { subMenu } = this.facetContent;
        const activeIndex = subMenu.indexOf(item);
        subMenu.splice(activeIndex, 1);
    }

    public createSubmenu() {
        return {
            [this.filterKey.labelKey]: null,
            [this.filterKey.valueKey]: null,
        };
    }

    public initiateCustomMapping() {
        const selectedFacetItem = this.selectedFacetItem;
        if (selectedFacetItem) {
            const customMapper = selectedFacetItem.customMapper;
            if (customMapper) {
                this.customMapper = customMapper;
            }
        }
    }

    public validateCustomMapper() {
        const customMapper = this.customMapper;
        const mapperValues = Object.values(customMapper);
        const unFilledArea = mapperValues.filter((item) => !item);
        if (!unFilledArea.length) {
            this.selectedFacetItem.customMapper = this.customMapper;
        }
    }

    // -------------------------------------------------------
    // Hooks

    private created() {
        if (this.selectedFacetItem) {
            this.facetContent = this.selectedFacetItem;
            this.hasSubmenu = !!this.selectedFacetItem.subMenu;
        }
        this.initiateCustomMapping();
    }

    private showSuccessToaster(description: string, heading: string) {
        this.$bvToast.toast(description, {
            title: heading,
            variant: 'success',
            solid: true,
          });
    }
}
